import _asyncToGenerator from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "C:\\Users\\eric.sangabriel\\Documents\\GitHub\\web\\node_modules\\@babel\\runtime\\regenerator\\index.js";
import { globalThis, document } from "./server-safe-globals.js";
import { delay } from "./utils.js";
import { fullscreenApi } from "./fullscreen-api.js";
var testMediaEl;

var getTestMediaEl = function getTestMediaEl() {
  var _a, _b;

  if (testMediaEl) return testMediaEl;
  testMediaEl = (_b = (_a = document) == null ? void 0 : _a.createElement) == null ? void 0 : _b.call(_a, "video");
  return testMediaEl;
};

var hasVolumeSupportAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var mediaEl,
        prevVolume,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            mediaEl = _args.length > 0 && _args[0] !== undefined ? _args[0] : getTestMediaEl();

            if (mediaEl) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", false);

          case 3:
            prevVolume = mediaEl.volume;
            mediaEl.volume = prevVolume / 2 + 0.1;
            _context.next = 7;
            return delay(0);

          case 7:
            return _context.abrupt("return", mediaEl.volume !== prevVolume);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function hasVolumeSupportAsync() {
    return _ref.apply(this, arguments);
  };
}();

var hasPipSupport = function hasPipSupport() {
  var mediaEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getTestMediaEl();
  return typeof (mediaEl == null ? void 0 : mediaEl.requestPictureInPicture) === "function";
};

var hasFullscreenSupport = function hasFullscreenSupport() {
  var mediaEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getTestMediaEl();
  var fullscreenEnabled = document[fullscreenApi.enabled];

  if (!fullscreenEnabled && mediaEl) {
    fullscreenEnabled = "webkitSupportsFullscreen" in mediaEl;
  }

  return fullscreenEnabled;
};

var fullscreenSupported = hasFullscreenSupport();
var pipSupported = hasPipSupport();
var airplaySupported = !!globalThis.WebKitPlaybackTargetAvailabilityEvent;
var castSupported = !!globalThis.chrome;
export { airplaySupported, castSupported, fullscreenSupported, getTestMediaEl, hasFullscreenSupport, hasPipSupport, hasVolumeSupportAsync, pipSupported };